import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUIStore } from '@/store/uiStore';
import s from './ai.module.css';

export const FloatingAIButton: React.FC = () => {
  const location = useLocation();
  const { toggleAISlide, aiSlideOpen } = useUIStore();

  const isHomePage = location.pathname === '/' || location.pathname === '/dashboard';
  if (isHomePage) return null;

  return (
    <div className={s.floatingWrap}>
      <button
        onClick={toggleAISlide}
        aria-label={aiSlideOpen ? 'Close AI Manager' : 'Open AI Manager'}
        className={aiSlideOpen ? s.floatingBtnOpen : s.floatingBtn}
      >
        <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      </button>
    </div>
  );
};
